import React from "react";
import WheelColumn from "./WheelColumn";
import {
  PickerColon,
  PickerLabel,
  PickerWheels,
  PickerWrapper,
} from "./TimeWheelPicker.styles";

interface TimeWheelPickerProps {
  label: string;
  hour: string;
  minute: string;
  hourOptions: string[];
  minuteOptions: string[];
  onChange: (hour: string, minute: string) => void;
}

// Selector de hora con dos ruletas (horas y minutos). Reutilizable para la
// hora de inicio y la de fin del evento.
const TimeWheelPicker: React.FC<TimeWheelPickerProps> = ({
  label,
  hour,
  minute,
  hourOptions,
  minuteOptions,
  onChange,
}) => (
  <PickerWrapper>
    <PickerLabel>{label}</PickerLabel>
    <PickerWheels>
      <WheelColumn
        options={hourOptions}
        value={hour}
        onChange={(h) => onChange(h, minute)}
        ariaLabel={`${label} - horas`}
      />
      <PickerColon>:</PickerColon>
      <WheelColumn
        options={minuteOptions}
        value={minute}
        onChange={(m) => onChange(hour, m)}
        ariaLabel={`${label} - minutos`}
      />
    </PickerWheels>
  </PickerWrapper>
);

export default TimeWheelPicker;
